export default __webpack_public_path__ + "static/angie1-fbc31e9536f227cd0d4f1e513355e07f.jpg";